// components/InstructionsPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuiz } from '../context/QuizContext';

const InstructionsPage = () => {
  const navigate = useNavigate();
  const { state } = useQuiz();

  const handleContinue = () => {
    navigate('/camera');
  };

  return (
    <div className="instructions-page">
      <div className="instructions-container">
        <h1>Quiz Instructions</h1>
        <div className="instructions-content">
          <h2>Important Rules:</h2>
          <ul>
            <li>❌ Do not switch browser tabs or windows during the quiz</li>
            <li>❌ Do not minimize the browser window</li>
            <li>📹 Camera must remain active throughout the quiz</li>
            <li>⏱️ Total time: 30 minutes for the entire quiz</li>
            <li>⚠️ You will get 3 warnings for violations</li>
            <li>🚫 After 3 warnings, the quiz will auto-submit</li>
            <li>📵 No right-click, F12, or copy-paste allowed</li>
          </ul>

          <h2>Quiz Information:</h2>
          <ul>
            <li>Total Questions: 10</li>
            <li>Question Type: Multiple Choice</li>
            <li>Navigation: One question at a time</li>
            <li>Scoring: +10 points for correct answer</li>
          </ul>

          <div className="student-info">
            <h3>Student Information:</h3>
            <p><strong>Name:</strong> {state.studentInfo?.name}</p>
            <p><strong>Student ID:</strong> {state.studentInfo?.studentId}</p>
            <p><strong>Email:</strong> {state.studentInfo?.email}</p>
          </div>
        </div>

        <button onClick={handleContinue} className="btn-primary">
          Continue to Camera Setup
        </button>
      </div>
    </div>
  );
};

export default InstructionsPage;